function AdminDeleteIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.47653 0 0 4.47384 0 9.99399C0 15.5141 4.47653 20 10 20C15.5235 20 20 15.5141 20 9.99399C20 4.47384 15.5235 0 10 0ZM8.65223 5.19543C8.65223 5.19543 8.7485 5.1834 8.7846 5.1834C9.57882 5.1834 10.373 5.17138 11.1673 5.1834C11.4561 5.1834 11.6847 5.39988 11.7208 5.68852C11.7569 5.96512 11.5764 6.22971 11.2996 6.31389C11.2274 6.32592 11.1552 6.33794 11.071 6.33794H9.97593C9.57882 6.33794 9.18171 6.33794 8.7846 6.32592C8.50782 6.32592 8.27918 6.10944 8.24308 5.82081C8.20698 5.5442 8.38748 5.27962 8.65223 5.19543ZM15.2347 8.06975C14.8977 8.08178 14.5608 8.08178 14.2118 8.08178H14.0433V14.997C14.0433 15.8148 13.574 16.4762 12.8279 16.7048C12.6474 16.7649 12.4669 16.7889 12.2744 16.7889H7.68953C6.66667 16.7889 5.92058 16.0313 5.90854 15.009V8.06975C5.4994 8.06975 5.10229 8.08178 4.71721 8.06975C4.3201 8.05773 4.05535 7.64883 4.21179 7.27601C4.29603 7.05953 4.47653 6.93927 4.71721 6.92724C4.76534 6.91521 4.81348 6.91521 4.86161 6.91521H15.1023C15.1986 6.91521 15.2828 6.91521 15.3791 6.93927C15.6558 7.02345 15.8243 7.28803 15.7882 7.57667C15.7521 7.85328 15.5235 8.06975 15.2347 8.06975Z"
        fill="#EB5757"
      />
    </svg>
  );
}

export { AdminDeleteIcon };
